module.exports = __webpack_public_path__ + "static/media/mess.92e05014.png";